import {
  IonAccordion as IonicIonAccordion,
  IonItem as IonicIonItem,
} from '@ionic/react'
import styled from 'styled-components'

export const IonAccordion = styled(IonicIonAccordion)`
  background: transparent;
`

export const IonItem = styled(IonicIonItem)`
  --background: transparent;
  --background-hover: transparent;
  --border-width: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  height: 24px;
  display: flex;
  font-size: 18px;
  font-weight: 700;

  &::part(native) {
    --padding-start: 0;
  }

  ion-icon {
    width: 18px;
  }
`

export const Content = styled.div`
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
